{
  "title": "Team",
  "description": "Your team members and their roles, invitations and the security policy.",
  "invite": {
    "button": "Invite member",
    "title": "Invite team members",
    "description": "Each person gets an invitation link that works for 7 days.",
    "emails": "Email",
    "emailsHint": "Up to 10 addresses, separated by commas or spaces.",
    "role": "Role",
    "message": "Message with the invitation",
    "messagePlaceholder": "For example: adding you to look after the new servers.",
    "submit": "Send invitation",
    "demoHint": "In the demo, the invitee accepts automatically after about 25 seconds.",
    "errors": {
      "invalid": "This email is not valid: {{email}}",
      "tooMany": "Up to 10 invitations at a time.",
      "member": "{{email}} is already on the team.",
      "invited": "{{email}} already has an open invitation. Resend it from the invitations list."
    },
    "submitMany_one": "Send invitation",
    "submitMany_other": "Send {{count}} invitations",
    "sent_one": "Invitation sent",
    "sent_other": "{{count}} invitations sent"
  },
  "members": {
    "caption": "Team members",
    "search": "Search by name or email",
    "columns": {
      "member": "Member",
      "role": "Role",
      "twoFactor": "Two-factor",
      "lastActive": "Last active",
      "joined": "Joined"
    },
    "you": "You",
    "twoFactorOn": "On",
    "twoFactorOff": "Off",
    "never": "Not signed in yet",
    "empty": "No members yet",
    "readOnly": "Your role is {{role}}, so you can view the team. Only the owner and admins manage members and invitations."
  },
  "actions": {
    "changeRole": "Change role",
    "remove": "Remove from team",
    "leave": "Leave organisation"
  },
  "changeRole": {
    "title": "Change role",
    "description": "Choose the new role for {{name}}. It applies right away.",
    "submit": "Save role"
  },
  "remove": {
    "title": "Remove this member?",
    "description": "{{name}} loses access to {{org}} right away and their open sessions end. You can invite them again later.",
    "confirm": "Remove member"
  },
  "leave": {
    "title": "Leave {{org}}?",
    "description": "You lose access to this organisation's servers, invoices and tickets. You can only come back with a new invitation.",
    "confirm": "Leave organisation"
  },
  "invitations": {
    "title": "Invitations",
    "sentBy": "Sent by {{name}}, {{when}}",
    "expired": "Expired",
    "actions": "Actions for the invitation to {{email}}",
    "resend": "Resend",
    "resendExpired": "Send a new invitation",
    "copyLink": "Copy invitation link",
    "revoke": "Revoke invitation",
    "linkCopied": "Invitation link copied",
    "linkCopyManual": "Copy the invitation link",
    "revokeTitle": "Revoke this invitation?",
    "revokeDescription": "The link sent to {{email}} stops working.",
    "description_one": "1 invitation not accepted yet.",
    "description_other": "{{count}} invitations not accepted yet.",
    "description_zero": "No open invitations.",
    "expires_one": "Expires in 1 day",
    "expires_other": "Expires in {{count}} days",
    "expires_zero": "Expires today"
  },
  "policy": {
    "title": "Security policy",
    "description": "Applies to every member of the organisation.",
    "label": "Require two-factor authentication for all members",
    "hint": "Anyone who has not set it up is asked to at their next sign-in.",
    "updatedBy": "Turned on by {{name}}, {{when}}",
    "setUp": "Set up two-factor authentication",
    "needYour2fa": "Turn on two-factor authentication for your own account first, then require it for the team.",
    "readOnly": "Only the owner and admins can change this policy.",
    "enableTitle": "Require two-factor authentication?",
    "disableTitle": "Stop requiring two-factor authentication?",
    "disableDescription": "Members can sign in with a password alone. We recommend keeping it on, since the account holds activation keys and invoices.",
    "enable": "Require for the team",
    "disable": "Stop requiring",
    "membersWithout_one": "1 member hasn't turned on two-factor authentication.",
    "membersWithout_other": "{{count}} members haven't turned on two-factor authentication.",
    "membersWithout_zero": "Every member has two-factor authentication on.",
    "enableDescription_one": "Every member will need a two-factor code to sign in. 1 member hasn't set it up yet and will be asked to at their next sign-in.",
    "enableDescription_other": "Every member will need a two-factor code to sign in. {{count}} members haven't set it up yet and will be asked to at their next sign-in.",
    "enableDescription_zero": "Every member will need a two-factor code to sign in. Everyone already has it on."
  },
  "matrix": {
    "title": "Roles and permissions",
    "description": "What each role can do in your organisation's account.",
    "roleLabel": "Choose a role",
    "capability": "Permission",
    "yourRole": "Your role",
    "yes": "Allowed",
    "no": "Not allowed",
    "caps": {
      "servers_view": "View servers and their status",
      "support_use": "Open and reply to support tickets",
      "releases_view": "Read release notes",
      "servers_manage": "Add, install and transfer servers, and manage activation keys",
      "diagnostics_share": "Share diagnostics with support",
      "billing_manage": "Change plans, payment methods, invoices and billing details",
      "credits_manage": "Buy AI credits and change AI settings",
      "servers_cancel": "Cancel or resume a server's subscription, remove a pending server",
      "team_manage": "Invite members and manage roles",
      "org_manage": "Organisation details and security policy",
      "org_owner": "Transfer ownership and delete the organisation"
    }
  },
  "transfer": {
    "title": "Transfer ownership",
    "description": "The new owner gets every permission and you become an admin.",
    "member": "New owner",
    "pick": "Choose a member",
    "none": "No other members",
    "needs2fa": "Needs two-factor authentication first",
    "button": "Transfer ownership",
    "memberHint": "The new owner must have two-factor authentication on.",
    "confirmTitle": "Transfer ownership?",
    "confirmDescription": "{{name}} becomes the owner and you become an admin. Only the new owner can give it back.",
    "confirm": "Transfer ownership"
  },
  "toasts": {
    "roleChanged": "Role changed",
    "removed": "Member removed",
    "transferred": "Ownership transferred",
    "resent": "Invitation sent again",
    "revoked": "Invitation revoked",
    "left": "You left {{org}}"
  },
  "accept": {
    "documentTitle": "Invitation",
    "loading": "Loading the invitation",
    "title": "Join {{org}}",
    "description": "{{inviter}} invited you to join the {{org}} team on bPanel.",
    "organization": "Organisation",
    "invitedBy": "Invited by",
    "role": "Your role",
    "email": "Email",
    "expires": "The invitation is valid until {{date}}.",
    "join": "Accept and open {{org}}",
    "existing": "You have an account with {{email}}. Sign in to accept the invitation.",
    "signInToAccept": "Sign in to accept",
    "createTitle": "Create your account",
    "name": "Full name",
    "password": "Password",
    "createAndJoin": "Create account and join",
    "haveAccount": "Already have an account with this email?",
    "signIn": "Sign in",
    "home": "Back to home",
    "notFound": {
      "title": "We couldn't find this invitation",
      "body": "Make sure you opened the full link from the invitation email, or ask for a new invitation."
    },
    "closed": {
      "expired": {
        "title": "This invitation has expired",
        "body": "Invitations to {{org}} last 7 days. Ask {{inviter}} to send you a new one."
      },
      "revoked": {
        "title": "This invitation was revoked",
        "body": "The invitation to {{org}} was revoked. If you expected access, contact {{inviter}}."
      },
      "accepted": {
        "title": "This invitation was already accepted",
        "body": "You're a member of {{org}}. Sign in to continue."
      }
    },
    "mismatch": {
      "title": "This invitation is for another email",
      "body": "You're signed in as {{current}}, but the invitation was sent to {{email}}.",
      "signOut": "Sign out and continue"
    }
  }
}
